import React from "react";
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from './Routes/Home';
import About from './Routes/About';
import Service from './Routes/Service';
import Search from './Routes/Search';
import SearchID from './Routes/SearchID';
import Country from './Routes/Country';
import Nav from './Routes/Nav';
import './Routes/meal.css';


function App(){
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Nav />} >
                   <Route index element={<Home />}/>
                   <Route path="/about" element={<About />}/>
                   <Route path="/service" element={<Service />}/>
                   <Route path="/country" element={<Country />}/>
                   <Route path="/search" element={<Search />}/>
                   <Route path="/search/:searchid" element={<SearchID />}/>
                </Route>
                <Route path='*' element={<h1>errror not found....!!!!</h1>} />
            </Routes>
        </BrowserRouter>

    )
}
export default App;